<template>
<div v-if="checkPermission(c_permission)">
  <b-button :type="type" style="white-space: nowrap;" :class="classButton"  :variant="variant" size="sm" :disabled="loading || disabled"><i
    :class="{'fa fa-spinner fa-spin fa-fw' : loading}"></i>
    <slot>{{$t('SAVE')}}</slot>
  </b-button>
</div>

</template>

<script>
    export default {
        name: "AppSubmit",
      props: {
        loading: {
          type: Boolean,
          default: false
        },
        disabled: {
          type: Boolean,
          default: false
        },
        c_permission:{
          type:Number
        },
        type:{
          type:String,
          default:'submit'
        },
        button_type: {
          type:String,
        },
        variant:{
          type:String
        }
      },
      computed:{
        classButton(){
          if(this.button_type === 'search'){
            return 'filter-button search'
          }else if((this.button_type === 'reset')){
            return ''
          } else {
            return 'btn-success'
          }

        }
      }
    }
</script>

<style scoped>

</style>
